import roles from '@/app/bsg/decarbonization/roles.js'

export default [
  {
    path: '/bsg/decarbonization',
    name: 'BSG-decarbonization',
    component: () => import('@/app/bsg/decarbonization/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Decarbonization', active: true, i18n: 'Decarbonization.Title' }
      ],
      pageTitle: 'Decarbonization',
      i18n: 'Decarbonization.Title',
      requireAuth: true,
      requireRoles: roles.readers
    }
  },
  {
    path: '/bsg/decarbonization/admin',
    name: 'BSG-decarbonization-admin',
    component: () => import('@/app/bsg/decarbonization/admin/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Decarbonization', url: '/bsg/decarbonization',  i18n: 'Decarbonization.Title' },
        { title: 'Admin', active: true,  i18n: 'Decarbonization.Admin.Title' }
      ],
      pageTitle: 'Admin',
      i18n: 'Decarbonization.Admin.Title',
      requireAuth: true,
      requireRoles: roles.admins
    }
  },
  {
    path: '/bsg/decarbonization/admin/complexityParameters',
    name: 'BSG-decarbonization-admin-complexityParameters',
    component: () => import('@/app/bsg/decarbonization/admin/complexityParameters/ComplexityParameters.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Decarbonization', url: '/bsg/decarbonization',  i18n: 'Decarbonization.Title' },
        { title: 'Admin', url: '/bsg/decarbonization/admin',  i18n: 'Decarbonization.Admin.Title' },
        { title: 'ComplexityParameters', active: true, i18n: 'Decarbonization.ComplexityParameter.Title' }
      ],
      pageTitle: 'ComplexityParameters',
      i18n: 'Decarbonization.ComplexityParameter.Title',
      requireAuth: true,
      requireRoles: roles.admins
    }
  },
  {
    path: '/bsg/decarbonization/admin/energySourceUnitConversion',
    name: 'BSG-decarbonization-admin-energySourceUnitConversion',
    component: () => import('@/app/bsg/decarbonization/admin/unitConversions/UnitConversions.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Decarbonization', url: '/bsg/decarbonization',  i18n: 'Decarbonization.Title' },
        { title: 'Admin', url: '/bsg/decarbonization/admin',  i18n: 'Decarbonization.Admin.Title' },
        { title: 'EnergySourceUnitConversion', active: true, i18n: 'Decarbonization.EnergySourceUnitConversion.Title' }
      ],
      pageTitle: 'EnergySourceUnitConversion',
      i18n: 'Decarbonization.EnergySourceUnitConversion.Title',
      requireAuth: true,
      requireRoles: roles.admins
    }
  },
  {
    path: '/bsg/decarbonization/admin/energySupplyTemplates',
    name: 'BSG-decarbonization-admin-energySupplyTemplates',
    component: () => import('@/app/bsg/decarbonization/admin/energySupplyTemplates/EnergySupplyTemplates.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Decarbonization', url: '/bsg/decarbonization',  i18n: 'Decarbonization.Title' },
        { title: 'Admin', url: '/bsg/decarbonization/admin',  i18n: 'Decarbonization.Admin.Title' },
        { title: 'EnergySupplyTemplates', active: true, i18n: 'Decarbonization.EnergySupplyTemplate.Title' }
      ],
      pageTitle: 'EnergySupplyTemplates',
      i18n: 'Decarbonization.EnergySupplyTemplate.Title',
      requireAuth: true,
      requireRoles: roles.admins
    }
  },
  {
    path: '/bsg/decarbonization/admin/energySupplyTemplates/edit',
    name: 'BSG-decarbonization-energySupplyTemplates-edit',
    component: () => import('@/app/bsg/decarbonization/admin/energySupplyTemplates/edit.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Decarbonization', url: '/bsg/decarbonization', i18n: 'Decarbonization.Title' },
        { title: 'Admin', url: '/bsg/decarbonization/admin', i18n: 'Decarbonization.Admin.Title' },
        { title: 'EnergySupplyTemplates', url: '/bsg/decarbonization/admin/energySupplyTemplates', i18n: 'Decarbonization.EnergySupplyTemplate.Title' },
        { title: 'Edit', active: true, i18n: 'Decarbonization.EnergySupplyTemplate.Edit' }
      ],
      pageTitle: 'EnergySupplyTemplatesEdit',
      i18n: 'Decarbonization.EnergySupplyTemplate.Edit',
      rule: 'editor',
      requireAuth: true,
      requireRoles: roles.admins
    }
  },
  {
    path: '/bsg/decarbonization/admin/gridEfficiencyTemplates',
    name: 'BSG-decarbonization-admin-gridEfficiencyTemplates',
    component: () => import('@/app/bsg/decarbonization/admin/gridEfficiencyTemplates/GridEfficiencyTemplates.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Decarbonization', url: '/bsg/decarbonization',  i18n: 'Decarbonization.Title' },
        { title: 'Admin', url: '/bsg/decarbonization/admin',  i18n: 'Decarbonization.Admin.Title' },
        { title: 'GridEfficiencyTemplates', active: true, i18n: 'Decarbonization.GridEfficiencyTemplate.Title' }
      ],
      pageTitle: 'GridEfficiencyTemplates',
      i18n: 'Decarbonization.GridEfficiencyTemplate.Title',
      requireAuth: true,
      requireRoles: roles.admins
    }
  },
  {
    path: '/bsg/decarbonization/energyScenarios',
    name: 'BSG-decarbonization-energyScenarios',
    component: () => import('@/app/bsg/decarbonization/energyScenarios/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Decarbonization', url: '/bsg/decarbonization',  i18n: 'Decarbonization.Title' },
        { title: 'EnergyScenarios', active: true,  i18n: 'Decarbonization.EnergyScenarios.Title' }
      ],
      pageTitle: 'EnergyScenarios',
      i18n: 'Decarbonization.EnergyScenarios.Title',
      requireAuth: true,
      requireRoles: roles.admins
    }
  },
  {
    path: '/bsg/decarbonization/admin/gridEfficiencyTemplates/edit',
    name: 'BSG-decarbonization-gridEfficiencyTemplates-edit',
    component: () => import('@/app/bsg/decarbonization/admin/gridEfficiencyTemplates/edit.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Decarbonization', url: '/bsg/decarbonization', i18n: 'Decarbonization.Title' },
        { title: 'Admin', url: '/bsg/decarbonization/admin', i18n: 'Decarbonization.Admin.Title' },
        { title: 'GridEfficiencyTemplates', url: '/bsg/decarbonization/admin/gridEfficiencyTemplates', i18n: 'Decarbonization.GridEfficiencyTemplate.Title' },
        { title: 'Edit', active: true, i18n: 'Decarbonization.GridEfficiencyTemplate.Edit' }
      ],
      pageTitle: 'GridEfficiencyTemplatesEdit',
      i18n: 'Decarbonization.GridEfficiencyTemplate.Edit',
      rule: 'editor'
    }
  },
  {
    path: '/bsg/decarbonization/energyScenarios/edit',
    name: 'BSG-decarbonization-energyScenarios-edit',
    component: () => import('@/app/bsg/decarbonization/energyScenarios/edit.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Decarbonization', url: '/bsg/decarbonization',  i18n: 'Decarbonization.Title' },
        { title: 'EnergyScenarios', url: '/bsg/decarbonization/energyScenarios', i18n: 'Decarbonization.EnergyScenarios.Title' },
        { title: 'Edit', active: true, i18n: 'Decarbonization.EnergyScenarios.Edit' }
      ],
      pageTitle: 'EnergyScenariosEdit',
      i18n: 'Decarbonization.EnergyScenarios.Edit',
      requireAuth: true,
      requireRoles: roles.readers
    }
  },
  {
    path: '/bsg/decarbonization/report',
    name: 'BSG-decarbonization-report',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'decarbonizationGroupId',
      reportId: 'decarbonization'
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Decarbonization', url: '/bsg/decarbonization',  i18n: 'Decarbonization.Title' },
        { title: 'Report', active: true, i18n: 'Decarbonization.Report' }
      ],
      requireAuth: true,
      requireRoles: roles.readers,
      pageTitle: 'Decarbonization Report',
      i18n: 'Decarbonization.Report'     
    }
  }
]